export default {
  timeSelectionTriggerLabel: '00000000-000000-0000',
  timeSelectionHeader: '31102025-144949-4033',
  filterTimeFromLabel: '16112018-091233-5309',
  filterTimeUntilLabel: '16112018-091512-8215',

  chooseAPredefinedSlot: '23012026-084813-9540',
  orCustomTime: '23012026-084650-3421',
  theExactTimesMayVary: '10062022-093015-0008',
  allDay: '19042022-141016-0036',
  morning: '19042022-141016-0034',
  afternoon: '19042022-141016-0035',
  save: '10082020-095421-0328',
  sorryTheDiscount: '10062022-093015-0009',
  whatWouldYouLike: '10062022-093015-0011',
  youSelectedHowever: '10062022-093015-0010',
  changeTo: '10062022-093015-0012',
  keepThe: '10062022-093015-0013',
  selectAnotherLocation: '10062022-093015-0014',
  confirm: '15112016-102627-9036',
  discountForAllAfternoon: '10062022-093015-0003',
  discountForAllDay: '10062022-093015-0002',
  discountForAllMorning: '10062022-093015-0001'
};
